import { render } from "./ProjectsList.vue?vue&type=template&id=be6b2d2e&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=be6b2d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6b2d2e"]])

export default __exports__